import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { environment } from "environments/environment";
import { CookieService } from "ngx-cookie-service";
import { EtrackerConsentService } from "./e-tracker-consent.service";
import { distinctUntilChanged, Subscription } from "rxjs";
import { DISABLE_ETRACKER_COOKIE_KEY } from "app/common";

@Injectable({
  providedIn: "root"
})
export class EtrackerService {
  private trackerInitialized = false;
  private routerSub: Subscription | null = null;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private consent: EtrackerConsentService
  ) {
    if (environment.etrackerSecureCode) {
      this.consent.analyticsConsentChanges$.pipe(distinctUntilChanged()).subscribe((allow) => {
        if (this.cookieService.get(DISABLE_ETRACKER_COOKIE_KEY) === "false") {
          this.initTracker();
          this.subscribeToRouter();
        } else {
          this.unSubscribeToRouter();
          this.destroyTracker();
        }
      });
    }
  }

  private initTracker(): void {
    if (this.trackerInitialized) {
      return;
    }
    (window as any).et_proxy_redirect = "//webcontr.taxando.de";

    const script = document.createElement("script");
    script.id = "_etLoader";
    script.type = "text/javascript";
    script.charset = "UTF-8";
    script.async = true;
    script.src = "//webcontr.taxando.de/code/e.js";
    script.setAttribute("data-block-cookies", "true");
    script.setAttribute("data-secure-code", environment.etrackerSecureCode);
    document.head.appendChild(script);

    this.trackerInitialized = true;
  }

  private subscribeToRouter(): void {
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.trackPage(event.urlAfterRedirects);
      }
    });
  }

  private unSubscribeToRouter(): void {
    this.routerSub?.unsubscribe();
    this.routerSub = null;
    this.trackerInitialized = false;
    document.getElementById("_etLoader")?.remove();
  }

  private destroyTracker(): void {
    if (!this.trackerInitialized) {
      return;
    }
    const script = document.getElementById("_etLoader");
    if (script && script.parentNode) {
      script.parentNode.removeChild(script);
    }
    delete (window as any).et_proxy_redirect;
    delete (window as any)._etracker;
    delete (window as any).et_eC_Wrapper;

    this.trackerInitialized = false;
  }

  trackPage(pageName: string, areas?: string): void {
    if (typeof (window as any)._etracker === "object" && typeof (window as any).et_eC_Wrapper === "function") {
      (window as any).et_eC_Wrapper({
        et_et: environment.etrackerSecureCode,
        et_pagename: pageName,
        ...(areas ? { et_areas: areas } : {})
      });
    }
  }
}
